import { jsxs, jsx } from "react/jsx-runtime";
import * as React from "react";
import { cx } from "../internal/cx.js";
import { useFieldControl } from "./Field.js";
import { joinIds } from "./internal.js";
const UnitInput = React.forwardRef(function UnitInput2({ unit, wrapperClassName, inputMode = "decimal", "aria-describedby": describedBy, ...props }, ref) {
  const unitId = `${React.useId()}-unit`;
  const { className, ...rest } = useFieldControl({ ...props, "aria-describedby": joinIds(describedBy, unitId) });
  return /* @__PURE__ */ jsxs("div", { className: cx("ev-unit", wrapperClassName), children: [
    /* @__PURE__ */ jsx("input", { ref, className: cx("ev-input", "ev-num", className), inputMode, ...rest }),
    /* @__PURE__ */ jsx("span", { id: unitId, className: "ev-unit__suffix", children: unit })
  ] });
});
UnitInput.displayName = "UnitInput";
export {
  UnitInput
};
//# sourceMappingURL=UnitInput.js.map
